import * as actionTypes from './actionTypes';

export const init = (payload) => ({ type: actionTypes.INITIALIZE, payload });
export const getDraftSuccess = (payload) => ({ type: actionTypes.INITIALIZE_SUCCESS, payload });
export const getDraftFailure = (payload) => ({ type: actionTypes.INITIALIZE_FAILURE, payload });

export const getBankAccount = (payload) => ({ type: actionTypes.GETBANK, payload });
export const getBankAccountSuccess = (payload) => ({ type: actionTypes.GETBANK_SUCCESS, payload });
export const getBankAccountFailure = (payload) => ({ type: actionTypes.GETBANK_FAILURE, payload });

export const submit = (payload) => ({ type: actionTypes.SUBMIT, payload });
export const submitSuccess = (payload) => ({ type: actionTypes.SUBMIT_SUCCESS, payload });
export const submitDataFailure = (payload) => ({ type: actionTypes.SUBMIT_FAILURE, payload });

export const confirm = (payload) => ({ type: actionTypes.CONFIRM, payload });
export const confirmSuccess = (payload) => ({ type: actionTypes.CONFIRM_SUCCESS, payload });
export const confirmDataFailure = (payload) => ({ type: actionTypes.CONFIRM_FAILURE, payload });

export const reset = () => ({ type: actionTypes.RESET });
